<div>
  <span [className]="badgeClass">
    <span class="sr-only">{{ 'mydspace.status' | translate }}</span>
    {{('mydspace.status.' + badgeContent) | translate}}
    <span class="sr-only">, </span>
  </span>
</div>
